import { render, staticRenderFns } from "./BlockListView.vue?vue&type=template&id=3e3e1330&scoped=true&"
import script from "./BlockListView.vue?vue&type=script&lang=js&"
export * from "./BlockListView.vue?vue&type=script&lang=js&"
import style0 from "./BlockListView.vue?vue&type=style&index=0&id=3e3e1330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3e1330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e3e1330')) {
      api.createRecord('3e3e1330', component.options)
    } else {
      api.reload('3e3e1330', component.options)
    }
    module.hot.accept("./BlockListView.vue?vue&type=template&id=3e3e1330&scoped=true&", function () {
      api.rerender('3e3e1330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/ubossOnePage/BlockListView.vue"
export default component.exports